import React, {useEffect, useState} from 'react';
import axios from 'axios';
import Title from '../common/Title'
import { Table,Badge,  Form, FormGroup, FormControl, FormLabel, Button,Modal, Container } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

export default function Releases() {
    const { user, logout } = useAuth();
    const [selectedGenre, setSelectedGenre] = useState('');
    const [artists, setArtists] = useState([]);
    const [releases, setReleases] = useState([]);    
    const [loading, setLoading] = useState(true);
    const [progress, setProgress] = useState(true);
    const [error, setError] = useState(null);
    const [file, setFile] = useState(null);
    const [audiofile, setFileAudio] = useState(null);
    const [message, setMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [release, setRelease] = useState({
        labels: "",
        language: "",
        format: "",
        upc_code: "",
        reference_number: "",
    });
    const handleEdit = (e) => {
        setRelease({ ...release, [e.target.name]: e.target.value });
    };
    const [selectedValue, setSelectedValue] = useState('');
    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };
    const genres = [
        { id: 1, name: '7 Digital' },
        { id: 2, name: 'AWA' },
        { id: 3, name: 'Amazon Music' },
        { id: 4, name: 'Anghami' },
        { id: 5, name: 'Audible Magic Fingerprinting' },
        { id: 6, name: 'BMAT' },
        { id: 7, name: 'Boomplay' },
        { id: 8, name: 'Claro musica' },
        { id: 9, name: 'Deezer' },
        { id: 10, name: 'Facebook Rights Manager' },
        { id: 11, name: 'Gaana' },
        { id: 12, name: 'Gracenote' },
        { id: 14, name: 'Hungama' },
        { id: 15, name: 'iHeart' },
        { id: 16, name: 'iTunes/Apple Music' },
        { id: 17, name: 'JOOX' },
        { id: 18, name: 'Jaxsta' },
        { id: 19, name: 'Jio Saavn' },
        { id: 20, name: 'KDigital Media' },
        { id: 21, name: 'Kanjian' },
        { id: 22, name: 'Kkbox' },
        { id: 23, name: 'Lickd' },
        { id: 24, name: 'MixCloud' },
        { id: 25, name: 'NewEase Cloud Music' },
        { id: 26, name: 'Pandora' },
        { id: 27, name: 'Peloton' },
        { id: 28, name: 'Resso' },
        { id: 29, name: 'Rhapsody/Napster' },
        { id: 30, name: 'Sound Cloud' },
        { id: 31, name: 'Spotify' },
        { id: 32, name: 'Tencent' },
        { id: 33, name: 'Tidal' },
        { id: 34, name: 'Tik Tok' },
        { id: 35, name: 'Twitch' },
        { id: 36, name: 'Wynk' },
        { id: 37, name: 'Youtube Audio Content ID' },
        { id: 38, name: 'Youtube Music' },
    ];

    const handleGenre = (event) => {
        setSelectedGenre(event.target.value);
    };   
    const handleShowModal = () => {
        setShowModal(true);
    };
    const handleCloseModal = () => {
        if (!loading) {
            setShowModal(false); // Allow modal to close only when it's not loading
        }
        setShowModal(false);
    };
    // Handle file selection
    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if(selectedFile){
            const isValidType = selectedFile.type === 'image/jpeg' || selectedFile.type === 'image/png';
            const maxSize = 100 * 1024 * 1024;
            const isValidSize = selectedFile.size <= maxSize;
            if (!isValidType) {
                setError('Please select a JPEG or PNG file.');
                setFile(null);
            } else if (!isValidSize) {
                setError('File size exceeds 2MB. Please select a smaller file.');
                setFile(null);
            } else {
                setFile(selectedFile);
                setError('');
            }
        }
    };
    const handleTrackChange = (event) => {
        const selectedFile = event.target.files[0];
        if(selectedFile){
            const isValidType = selectedFile.type === 'audio/mpeg' || selectedFile.type === 'audio/wav';
            const maxSize = 200 * 1024 * 1024;
            const isValidSize = selectedFile.size <= maxSize;
            if (!isValidType) {
                setError('Please select a mp4 or mp3 file.');
                setFileAudio(null);
            } else if (!isValidSize) {
                setError('File size exceeds 2MB. Please select a smaller file.');
                setFileAudio(null);
            } else {
                setFileAudio(selectedFile);
                setError('');
            }
        }
    };
    const baseUrl = 'http://dawsonhighwaycafeandindiancuisine.com/music-dashboard/public';
    const optionElements = [];
    useEffect(() => {
        // Early return if the user is not logged in
        if (!user.isLoggedIn) {
            return;
        }
        // Set the loading state to true
        setLoading(true);

        // Define the API URL based on the user's role
        const fetchUrl =
            user.role === 'super_admin' || user.role === 'admin'
                ? '/api/artists'
                : `/api/user/${user.user_id}/artists`;

        axios
            .get(baseUrl + fetchUrl)
            .then((response) => {
                setArtists(response.data.artists);
            })
            .catch((err) => {
                // setError('Error fetching data');
            })
            .finally(() => {
                setLoading(false);
            });
        // Get Releases
        const fetchReleases =
        user.role === 'super_admin' || user.role === 'admin'
            ? '/api/releases'
            : `/api/${user.user_id}/releases`;

        axios
            .get(baseUrl + fetchReleases)
            .then((response) => {
                setReleases(response.data.releases);
            })
            .catch((err) => {
                setError('Error fetching data');
            })
            .finally(() => {
                setLoading(false);
            });
    }, [user]);
    // if (loading) {
    //     return <div>Loading...</div>;
    // }

    if (error) {
        return <div>{error}</div>;
    }
    const deleteArtist = async (id) => {
        const confirmSubmit = window.confirm("Are you sure you want to delete?");
        if (!confirmSubmit) return;
        try {
            const response = await axios.delete(baseUrl + `/api/releases/${id}`);
            if (response.data.status === 200) {
                setMessage(response.data.message);
                window.location.reload();
            } else {
                setMessage("❌ Failed to delete!");
            }
        } catch (error) {
            setMessage("❌ Error deleting data!");
        }
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        const obj = {
            'artist_id': selectedValue,
            'cover_image': file.name,
            'labels': release.labels,
            'genre': selectedGenre,
            'language': release.language,
            'format': release.format,
            'track': audiofile.name,
            'upc_code':release.upc_code,
            'reference_number':release.reference_number
        };
        setLoading(true);
        setProgress(0);
        try {
            const response = await axios.post('http://dawsonhighwaycafeandindiancuisine.com/api/add_release.php', {
                params: {
                    'artist_id': selectedValue,
                    'cover_image': file,
                    'labels': release.labels,
                    'genre': selectedGenre,
                    'language': release.language,
                    'format': release.format,
                    'track': audiofile,
                    'upc_code':release.upc_code,
                    'reference_number':release.reference_number
                }
            },{
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onUploadProgress: (progressEvent) => {
                    // Calculate the progress percentage
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setProgress(percentCompleted); // Update the progress
                }
            });
            if (response.data.status === 200) {
                setMessage(response.data.message);
                setRelease({
                    'artist_id': '',
                    'cover_image': '',
                    'labels': '',
                    'genre': '',
                    'language': '',
                    'format': '',
                    'track': '',
                    'upc_code':'',
                    'refrence_number':''
                });
                setShowModal(false);
            } else {
                setMessage("❌ Something went wrong!");
            }
        } catch (error) {
            setMessage("❌ Error submitting form!");
        } finally {
            setLoading(false);
        }
    }
    return (
        <div className='page_wrapper'>
            <div className='bg-dark text-white p-2'>
                <h4 className='release_text'>Release</h4>
                <Button className="btn release_modal_btn" onClick={() => handleShowModal()}>Add Release</Button>
            </div>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Artist</th>
                        <th>Artist Email</th>
                        <th>Phone</th>
                        <th>Cover Image</th>
                        <th>Labels/Genre/Language</th>
                        <th>Track</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {releases.map((release, index) => (
                        <tr key={release.id || index}>
                            <td>{index + 1}</td>
                            <td>{release.artist.name}</td>
                            <td>{release.artist.email}</td>
                            <td>{release.artist.phone_number}</td>
                            <td style={{width:'250px'}}><img style={{width:'100%'}} src={`${baseUrl}${release.cover_image}`} alt="Cover Image" /></td>
                            <td><Badge pill bg="primary">{release.labels}</Badge><Badge pill bg="danger">{release.genre}</Badge><Badge pill bg="success">{release.language}</Badge></td>
                            <td>
                                <audio controls>
                                    <source src={`${baseUrl}${release.track}`} type="audio/mp3" />
                                </audio>
                            </td>
                            <td>
                                <Button className="btn btn-xs btn-danger" onClick={() => deleteArtist(release.id)}> <i class="bi bi-trash3"></i> </Button>
                            </td>
                            {/* <td>
                                <Button className="btn btn-xs" onClick={() => handleShowModal(artist)}><i class="bi bi-eye"></i></Button>
                                <Button className="btn btn-xs btn-warning" onClick={() => handleEditModal(artist)}><i class="bi bi-pencil-square"></i></Button>
                                <Button className="btn btn-xs btn-danger" onClick={() => deleteArtist(artist.id)}> <i class="bi bi-trash3"></i> </Button>
                            </td> */}
                        </tr>
                    ))}
                </tbody>
            </Table>
            {/* Modal to view selected artist details */}
            <Modal show={showModal} onHide={handleCloseModal} className="modal-lg">
                <Modal.Header className='bg-dark text-white' closeButton>
                    <Modal.Title>Add Release</Modal.Title>
                </Modal.Header>
                <Modal.Body>                    
                    {message && <div className="alert alert-success">{message}</div>}
                    {loading && (
                        <div>
                            <p style={{color:"green"}}>Uploading: {progress}%</p>
                            <progress style={{ width: '100%', height: '20px', color: 'green', backgroundColor: '#e0e0e0', borderColor: 'green' }} value={progress} max="100"></progress>
                        </div>
                    )}
                    <form className='form_bg' onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Artists</label>
                            <select
                                className='form-control'
                                id="selectField"
                                value={selectedValue}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Please select...</option>
                                {artists.map((artist) => (
                                    <option key={artist.id} value={artist.id}>
                                        {artist.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Genre</label>
                            <select
                                className='form-control'
                                id="selectField"
                                name="genre"
                                value={selectedGenre}
                                onChange={handleGenre}
                                required
                            >
                                <option value="">Please select...</option>
                                {genres.map((genre) => (
                                    <option key={genre.id} value={genre.name}>
                                        {genre.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Cover Image</label>
                            <input 
                                className='form-control'
                                type="file" 
                                id="fileInput" 
                                name="cover_image"
                                onChange={handleFileChange} 
                                accept=".jpeg,.jpg,.png"
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Upload Track</label>
                            <input 
                                className='form-control'
                                type="file" 
                                name="track" 
                                onChange={handleTrackChange} 
                                accept=".mp3"
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Labels</label>
                            <input
                                type="text"
                                placeholder='Enter labels'
                                className="form-control"
                                name="labels"
                                value={release.labels}
                                onChange={handleEdit}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Language</label>
                            <select
                                className='form-control'
                                name="language"
                                value={release.language}
                                onChange={handleEdit}
                                required
                            >
                                <option value="">Please select...</option>
                                <option key="english" value="english">
                                    English
                                </option>
                                <option key="hindi" value="hindi">
                                    Hindi
                                </option>
                                <option key="punjabi" value="punjabi">
                                    Punjabi
                                </option>
                            </select>
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Format</label>
                            <input
                                type="text"
                                placeholder='Enter Format'
                                className="form-control"
                                name="format"
                                value={release.format}
                                onChange={handleEdit}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">UPC Code</label>
                            <input
                                type="text"
                                placeholder='Enter Code'
                                className="form-control"
                                name="upc_code"
                                value={release.upc_code}
                                onChange={handleEdit}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Reference Number</label>
                            <input
                                type="text"
                                placeholder='Enter Number'
                                className="form-control"
                                name="reference_number"
                                value={release.reference_number}
                                onChange={handleEdit}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <button type="submit" className="btn btn-success">Submit Here</button>
                        </div>                
                    </form>
                </Modal.Body>
                <Modal.Footer className='bg-dark text-white'>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
